var Observable_1 = require('../../Observable');
var distinctUntilChanged_1 = require('../../operator/distinctUntilChanged');
Observable_1.Observable.prototype.distinctUntilChanged = distinctUntilChanged_1.distinctUntilChanged;
//# sourceMappingURL=distinctUntilChanged.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/add/operator/distinctUntilChanged.js
 ** module id = 344
 ** module chunks = 1
 **/